import swal from 'sweetalert2'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowsRepeat, faScanner } from '@fortawesome/pro-light-svg-icons'

import { Button, Form } from '@domain-group/suit-theme'

import handleCallbackAction from '@functions/handleCallbackAction'
import { OrderModel } from '@models/order'

const confirmUnapproveOrder = (unapproveOrderFn: Function) => {
  const unapproveOrderPayload = {
    callbacks: {
      action: unapproveOrderFn,
      buildActionParams: () => ([{ include_order_items: true }]),
    },
    toastText: 'Order Unapproved',
  }

  swal.fire({
    confirmButtonColor: '#DD6B55',
    confirmButtonText: 'Yes, unapprove it.',
    icon: 'warning',
    showCancelButton: true,
    text: 'Are you sure? This will unapprove the order and cannot be reversed.',
    title: 'Unapprove Order?',
  }).then(({ value }) => {
    if (value){
      // @ts-expect-error TS2345
      handleCallbackAction(unapproveOrderPayload)
    }
  })
}

const confirmReprocessAPI = (reprocessAPIFn: Function) => {
  const reprocessAPIPayload = {
    callbacks: {
      action: reprocessAPIFn,
    },
    toastText: 'Reprocess API job queued',
  }

  swal.fire({
    confirmButtonColor: '#DD6B55',
    confirmButtonText: 'Yes, reprocess it.',
    icon: 'warning',
    showCancelButton: true,
    text: 'Are you sure? This may create a duplicate in the providers system.',
    title: 'Reprocess API Job?',
  }).then(({ value }) => {
    if (value){
      // @ts-expect-error TS2345
      handleCallbackAction(reprocessAPIPayload)
    }
  })
}

type ConfirmReprocessWebhookParams = {
  orderId: number,
  reprocessWebhookFn: Function,
}

const confirmReprocessWebhook = (params: ConfirmReprocessWebhookParams) => {
  const { orderId, reprocessWebhookFn } = params

  const reprocessAPIPayload = {
    callbacks: {
      action: reprocessWebhookFn,
    },
    entityParams: { entity_id: orderId, entity_type: 'Order', event: 'order.approved' },
    toastText: 'Webhook successfully queued',
  }

  swal.fire({
    confirmButtonColor: '#DD6B55',
    confirmButtonText: 'Yes, reprocess webhook.',
    icon: 'warning',
    showCancelButton: true,
    text: 'Are you sure?',
    title: 'Reprocess Webhook?',
  }).then(({ value }) => {
    if (value){
      // @ts-expect-error TS2345
      handleCallbackAction(reprocessAPIPayload)
    }
  })
}

type ReprocessWebhookParams = {
  entity_id: number,
  entity_type: string,
  event: string,
}
interface EditOrderProcessingProps {
  callbacks:{
    reprocessAPI: () => void,
    reprocessWebhook: (reprocessWebhookParams: ReprocessWebhookParams) => void,
    unapproveOrder: () => void,
  },
  order: OrderModel,
}

const EditOrderProcessing = (props: EditOrderProcessingProps) => {
  const {
    callbacks, order,
  } = props

  const {
    reprocessAPI: reprocessAPIFn,
    reprocessWebhook: reprocessWebhookFn,
    unapproveOrder: unapproveOrderFn,
  } = callbacks

  return (
    <Form.Field label="Processing" marginTop="large">
      {!order.invoiced && (
        <Button
          buttonStyle="secondaryUtility"
          icon={<FontAwesomeIcon icon={faScanner} />}
          onClick={() => confirmUnapproveOrder(unapproveOrderFn)}
          size="medium"
        >
          Unapprove Order
        </Button>
      )}

      <Button
        buttonStyle="secondaryUtility"
        icon={<FontAwesomeIcon icon={faArrowsRepeat} />}
        marginTop="medium"
        onClick={() => confirmReprocessAPI(reprocessAPIFn)}
        size="medium"
      >
        Reprocess API
      </Button>

      <Button
        buttonStyle="secondaryUtility"
        icon={<FontAwesomeIcon icon={faArrowsRepeat} />}
        marginTop="medium"
        onClick={() => confirmReprocessWebhook({ orderId: order?.id, reprocessWebhookFn })}
        size="medium"
      >
        Reprocess Webhook
      </Button>
    </Form.Field>
  )
}

export default EditOrderProcessing
